import React from 'react';
import {Box} from "@mui/system";
import SectionHeader from "../../../../util/component/SectionHeader";
import {Grid} from "@mui/material";
import CardContainer from "../../common/components/CardContainer";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {useTranslation} from "react-i18next";
import {FormProductPlan} from "../../api/types/productPlan";
import {initialValues, validationSchema} from "./ProductPlanForm";
import ProductPlanHeader from './sections/ProductPlanHeader';
import ProductPlanRate from './sections/ProductPlanRate';
import ProductPlanException from './sections/ProductPlanException';
import ProductPlanExcess from './sections/ProductPlanExcess';
import Loading from "../../common/components/Loading";

const ProductPlan = () => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Form
    const form = useForm<FormProductPlan>({
        defaultValues: initialValues,
        resolver: yupResolver(
            validationSchema({t}),
        ),
        shouldUnregister: false
    });

    return (
        <Box>
            <SectionHeader title={"Product Plan"}/>
            <FormProvider {...form}>
                <CardContainer>
                    {/* HEADER */}
                    <ProductPlanHeader/>
                </CardContainer>
                <CardContainer>
                    <Grid container item xs={12} md={12} lg={12} spacing={2}>
                        <Grid item xs={12}>
                            {/* RATE */}
                            <ProductPlanRate/>
                        </Grid>
                        <Grid item xs={12}>
                            {/* EXCEPTION */}
                            <ProductPlanException/>
                        </Grid>
                        <Grid item xs={12}>
                            {/* EXCESS */}
                            <ProductPlanExcess/>
                        </Grid>
                    </Grid>
                </CardContainer>
            </FormProvider>
            <Loading/>
        </Box>
    );
}

export default ProductPlan;